import { appContainer } from "configuration/inversify/container/app";
import { wccModules } from "enums/wccModules";
import { ISignalRCoreManager } from "./interfaces/main";

const signalRManager = <ISignalRCoreManager>appContainer.get(wccModules.signalRManager);
export default signalRManager;